window.onload = function(){
    slider.init();
    sliderMulti.init();
    sliderHome.init();
    nav.init();
}